const BASE = "/api/ive/layout";

export async function listLayouts({ page = 1, pageSize = 20, sortOrder = "DESC", q = "" } = {}) {
  if (q && q.trim()) {
    const res = await fetch(`${BASE}/search`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: q, page, pageSize, sortOrder }),
    });
    if (!res.ok) throw new Error("Search failed");
    return await res.json();
  }
  const res = await fetch(`${BASE}?page=${page}&pageSize=${pageSize}&sortOrder=${sortOrder}`);
  if (!res.ok) throw new Error("List failed");
  return await res.json();
}

export async function createLayout({ name, config }) {
  const res = await fetch(`${BASE}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, config }),
  });
  if (!res.ok) {
    if (res.status === 409) throw new Error("A layout with this name already exists.");
    throw new Error("Create failed");
  }
  return await res.json();
}

export async function updateLayout({ id, name, config }) {
  const res = await fetch(`${BASE}/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, config }),
  });
  if (!res.ok) {
    if (res.status === 409) throw new Error("A layout with this name already exists.");
    throw new Error("Update failed");
  }
  return await res.json();
}

export async function deleteLayout(id) {
  const res = await fetch(`${BASE}/${id}`, { method: "DELETE" });
  if (!res.ok) throw new Error("Delete failed");
  return true;
}
